import { Box, Flex, Heading, Text } from '@podiumhq/design-system';
import {
  DISPLAY_MONTH_TERM,
  DISPLAY_YEAR_TERM,
  YEARLY_TERM,
} from '../constants';

const BundleCardPrice = ({
  bundleSlug,
  expiresAt,
  discountPercentage,
  discountPrice,
  headingProps = {},
  price,
  promoCode,
  smallTextProps = {},
  term,
  ...wrapperProps
}) => {
  // TODO add expire check
  const displayDiscount =
    !!promoCode && discountPercentage > 0 && discountPrice;
  const termText =
    term === YEARLY_TERM ? DISPLAY_YEAR_TERM : DISPLAY_MONTH_TERM;

  return (
    <Flex {...wrapperProps}>
      {displayDiscount && (
        <Text
          {...lightGreyTextStyles}
          fontSize="md"
          margin="16px 0 0 16px"
          textDecorationLine="line-through"
        >
          ${price}
        </Text>
      )}

      <Flex align="center" mb="16px" mt="8px">
        <Heading {...headingProps} {...baseHeadingStyles}>
          ${discountPrice}
        </Heading>

        <Box {...smallTextProps} {...baseSmallTextStyles}>
          <div>USD</div>
          <div>{`/${termText}`}</div>
        </Box>
      </Flex>
    </Flex>
  );
};

const lightGreyTextStyles = {
  color: 'grey.light',
  fontWeight: 'normal',
};

const baseHeadingStyles = {
  fontSize: '3xl',
  fontWeight: 'semibold',
};

const baseSmallTextStyles = {
  ...lightGreyTextStyles,
  fontSize: '8px',
};

export default BundleCardPrice;
